module.exports = __webpack_public_path__ + "img/10n.d40ae310.png";